<template>
    <QrWrapper>
        <div class="h-full flex flex-col max-w-xl mx-auto">
            <div class="flex mt-24">
                <LogoImage full class="mx-auto h-16 mb-4"/>
            </div>

            <QrForm @submit.prevent="login" class="space-y-4 px-6 py-5 sm:p-6 mt-2">
                <Message
                    v-if="newPassword"
                    info
                    :header="trans('message.your-password-was-updated')"
                    header-trans="message.your-password-was-updated"
                />

                <QrInput
                    v-model="email"
                    :label="trans('form.email')"
                    :errors="validationErrors.email"
                    trans="form.email"
                />

                <QrInput
                    v-model="password"
                    :label="trans('form.password')"
                    :errors="validationErrors.password"
                    trans="form.password"
                    type="password"
                >
                    <template #label-right>
                        <RouterLink to="/forgot-password" class="font-semibold text-indigo-600 hover:text-indigo-500">
                            {{ trans('button.forgot-password') }}
                            <TranslateText text="button.forgot-password"/>
                        </RouterLink>
                    </template>
                </QrInput>

                <QrButton
                    type="submit"
                    :loading="loading"
                    :text="trans('button.log-in')"
                    trans="button.log-in"
                    icon-right="arrow-right"
                    class="w-full"
                />
            </QrForm>

            <p class="mt-6 text-sm text-center text-gray-500">
                <QrParagraph :text="trans('text.dont-have-a-user?')" trans="dont-have-a-user?"/>
                <RouterLink to="/register" class="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
                    {{ trans('button.register') }}
                    <QrIcon icon="arrow-right"/>
                    <TranslateText text="button.register"/>
                </RouterLink>
            </p>
        </div>
    </QrWrapper>
</template>

<script setup>
import { onMounted, ref } from "vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import {getQueryParam, trans} from "@/libs/helper.js";
import QrInput from "@/components/application-ui/form/QrInput.vue";
import { useRoute, useRouter } from "vue-router";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import { useUserStore } from "@/store/user.js";
import { storeToRefs } from "pinia";
import TranslateText from "@/components/TranslateText.vue";
import QrParagraph from "@/components/application-ui/content/QrParagraph.vue";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import QrWrapper from "@/components/application-ui/panels/QrWrapper.vue";
import Message from "@/components/application-ui/feedback/Message.vue";
import LogoImage from "@/components/LogoImage.vue";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);
const newPassword = ref(false);
const email = ref('');
const password = ref('');
const validationErrors = ref({});
const loading = ref(false);
const route = useRoute();
const router = useRouter();

const login = async () => {
    await axios.get('/sanctum/csrf-cookie', {
        withCredentials: true,
    });

    try {
        await axios.post('/api/login', {
            email: email.value,
            password: password.value,
            remember: true,
        });

        await userStore.fetch();
        await router.push(route.query.redirect || '/dashboard');
    } catch (error) {
        validationErrors.value = error.response.data.errors;
    } finally {
        loading.value = false;
    }
}

onMounted(async () => {
    if (user.value) {
        if (route.query.redirect === '/') {
            await router.push('/dashboard');
        }

        await router.push(route.query.redirect || '/dashboard');
    }

    if (getQueryParam('newPassword') === '1') {
        newPassword.value = true;
    }

    email.value = getQueryParam('email');
});
</script>
